import React from "react";
import { motion } from "framer-motion";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import CircularLoader from "../CircularLoader/CircularLoader";
import { useTranslation } from "react-i18next";

const Confirm = ({
  open,
  setOpen,
  handleConfirm,
  text,
  loader = false,
  backdrop = false,
  // Say what each button does when "Cancel"/"Confirm" would be unclear,
  // e.g. "Keep shipment" / "Cancel shipment".
  cancelLabel,
  confirmLabel,
}) => {
  const { t } = useTranslation("common");
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 backdrop-blur-xs z-[9999999999]">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-ui-surface p-6 rounded-xl shadow-ui-md w-96 text-center border border-ui-border"
      >
        <div className="flex justify-center mb-4">
          <AiOutlineExclamationCircle className="w-14 h-14 text-state-warning-text" />
        </div>
        <p className="text-ui-text text-lg font-jakarta font-medium">
          {text || t("confirm.defaultText")}
        </p>
        <div className="flex justify-center gap-4 mt-6">
          {/* min-w keeps the old 8rem for short labels; longer ones widen
              the button instead of wrapping out of it. */}
          <button
            className="min-w-[8rem] px-[16px] whitespace-nowrap h-10 rounded-lg bg-ui-surface text-ui-text border border-ui-border hover:bg-ui-surface-sunken transition-all"
            onClick={() => setOpen(false)}
            disabled={loader}
          >
            {cancelLabel ?? t("actions.cancel")}
          </button>
          <button
            className={`min-w-[8rem] px-[16px] whitespace-nowrap h-10 rounded-lg text-white font-medium transition-all flex items-center justify-center ${
              loader
                ? "bg-ui-text-subtle cursor-not-allowed"
                : "bg-brand hover:bg-brand-hover"
            }`}
            onClick={handleConfirm}
            disabled={loader}
          >
            {loader ? (
              <>
                <CircularLoader />
              </>
            ) : (
              (confirmLabel ?? t("actions.confirm"))
            )}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default Confirm;
